import FormattedRecordTimestamp from '../../../utils/FormattedRecordTimestamp';
import { Contact } from '../../contacts/types';

export const useContactsTableColumns = () => {
    return [
        { accessor: 'givenName', title: 'Given Name' },
        { accessor: 'familyName', title: 'Family Name' },
        { accessor: 'email', title: 'Email' },
        { accessor: 'createdByUsername', title: 'Owner' },
        { accessor: 'created', title: 'Created', render: (row: Contact) => (
            <FormattedRecordTimestamp record={row} propertyName="created" />
        )}
    ];
};
